import { getMultiLangCategoriesList, getMultiLangCategoriesOptions } from './multiLangCategories';
import { createImmutableSelector } from './utils';
import { translate } from '../utils/categoryUtils';
const getCategoryOrganizationInfo = state => state.categoryOrganizationInfo;
export const selectCategories = createImmutableSelector([getCategoryOrganizationInfo], categoryOrganizationInfo => categoryOrganizationInfo.categories.map(category => translate({
  category,
  primaryLanguage: categoryOrganizationInfo.primaryLanguage,
  requestedLanguage: categoryOrganizationInfo.requestedLanguage
})));
export const selectCategoriesList = createImmutableSelector([getMultiLangCategoriesList], multiLangCategoriesList => {
  return multiLangCategoriesList;
});
export const selectCategoriesOptions = createImmutableSelector([getMultiLangCategoriesOptions], multiLangCategoriesOptions => {
  return multiLangCategoriesOptions;
});